import {Request} from "../../../request.abstract";
import {Settings} from "../../../settings.model";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Observable";

export class PlatformsEndpoint extends Request {
    protected messagecentralId: number;

    constructor(http: Http, settings: Settings, messagecentralId: number) {
        super(http, settings);
        this.messagecentralId = messagecentralId;
    }

    collection(offset: number = 0, limit: number = 100, minimaEnabled: boolean = true): Observable<any> {
        return this.get('/v1/messagecentrals/' + this.messagecentralId + '/proxy/platforms', this.createSearch({
            offset: offset,
            limit: limit
        }));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messagecentrals/proxy/platforms/api.service.ts